/*
 * iurop-shop — carrusel "Kawaii Café Shop".
 * Flechas prev/next que desplazan el track por un slide. Sin dependencias.
 */
(function () {
  function initCarousel(root) {
    if (root.dataset.ksInit) return;
    root.dataset.ksInit = '1';
    var track = root.querySelector('[data-ks-track]');
    var prev = root.querySelector('[data-ks-prev]');
    var next = root.querySelector('[data-ks-next]');
    if (!track) return;

    function step() {
      var slide = track.querySelector('.kawaii-shop__slide');
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return slide ? slide.offsetWidth + gap : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      // Ocultar (no deshabilitar) la flecha en el extremo: izq al inicio, dcha al final.
      prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    }
    // Destino REDONDEADO al paso de tarjeta: con scrollBy suelto, el reencaje del
    // scroll-snap dejaba la fila a media tarjeta.
    function go(dir) {
      var p = step();
      if (!p) return;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var t = Math.round((track.scrollLeft + dir * p) / p) * p;
      track.scrollTo({ left: Math.max(0, Math.min(t, max)), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    // Puntos de paginacion (movil): marcan la tarjeta CENTRADA en pantalla.
    var slides = Array.prototype.slice.call(track.querySelectorAll('.kawaii-shop__slide'));
    var dotsWrap = root.querySelector('[data-ks-dots]');
    function centerIdx() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var sl = slides[i], cc = sl.offsetLeft + sl.offsetWidth / 2, dd = Math.abs(cc - c);
        if (dd < bd) { bd = dd; best = i; }
      }
      return best;
    }
    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (sl, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kawaii-shop__dot';
        b.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
        b.addEventListener('click', function () {
          track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      });
    }
    function syncDots() {
      if (!dotsWrap || !dotsWrap.children.length) return;
      var a = centerIdx();
      for (var i = 0; i < dotsWrap.children.length; i++) {
        dotsWrap.children[i].classList.toggle('is-on', i === a);
      }
      for (var j = 0; j < slides.length; j++) slides[j].classList.toggle('is-center', j === a);
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { update(); syncDots(); });
    }, { passive: true });
    window.addEventListener('resize', function () { update(); syncDots(); });
    update();
    syncDots();
  }
  function boot() {
    document.querySelectorAll('[data-ks-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-ks-carousel]');
    if (c) initCarousel(c);
  });
})();
